import styled from 'styled-components';


const StyledSolutions = styled.section`
.font-36{
  font-size: 36px;
}
.gray-greadient{
  background: transparent linear-gradient(274deg, #FFFFFF 0%, #EAECF4 100%);
}
.section-solution{
  padding: 50px 5px 0px;
  img{
    filter: grayscale(100%);
    @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
      width: 100% !important;
      padding: 20px;
    };
  }
  .icon{
    @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
      width: 10% !important;
      padding: 0px !important;
    };
  }
}
.tabs{
  border-bottom:${({ theme }) => theme.webGray} solid 2px;
  padding: 20px 0px;
  .zaggle-emblem{
    position: absolute;
    right: 45px;
    top: 26.5rem;
    width: 6%;
  }
  ul{
    margin:0px;
    padding:0px;
    list-style:none;
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    li{
      margin:0px 100px;
      a{
        padding: 20px;
        font-family: 'Mulish',sans-serif;
        font-weight: 800;
        font-size:18px;
        color: ${({ theme }) => theme.LandingBlack};
        &:hover{
          color: ${({ theme }) => theme.primaryLight};
          border-bottom:${({ theme }) => theme.primaryLight} solid 5px;
        }
        &.active{
          color: ${({ theme }) => theme.primaryLight};
          border-bottom:${({ theme }) => theme.primaryLight} solid 5px;
        }
      }
    }
  }
}
`;

export default StyledSolutions;



// WEBPACK FOOTER //
// client/containers/NewLanding/Solutions/StyledSolutions.js